module.exports = __webpack_public_path__ + "img/solution-software-system-pic-4.03ae7ebb.png";